module.exports = (__webpack_require__(35444))(73712);